var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragImageIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 57,
    viewBox: "0 0 65 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0.5C6.37827 0.5 4.34344 1.34285 2.84315 2.84315C1.34285 4.34344 0.5 6.37827 0.5 8.5V48.5C0.5 50.6217 1.34285 52.6566 2.84315 54.1569C4.34344 55.6571 6.37827 56.5 8.5 56.5H56.5C58.6217 56.5 60.6566 55.6571 62.1569 54.1569C63.6571 52.6566 64.5 50.6217 64.5 48.5V8.5C64.5 6.37827 63.6571 4.34344 62.1569 2.84315C60.6566 1.34285 58.6217 0.5 56.5 0.5H8.5ZM56.5 48.5H8.5L24.5 16.5L36.5 40.5L44.5 24.5L56.5 48.5Z",
    fill: "#79747E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragImageIcon);
export default __webpack_public_path__ + "static/media/drag-image-icon.bab99b59ea918ff073212e81905a960f.svg";
export { ForwardRef as ReactComponent };